// ══════════════════════════════════════════════════════════════
// COMPASS – Authentication Guard
// ══════════════════════════════════════════════════════════════
import { inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, take, switchMap, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { AppState } from '../store/app.state';
import {
  selectIsInitialized,
  selectIsAuthenticated,
} from '../store/user/user.selectors';

/**
 * Functional guard that ensures the user is authenticated.
 *
 * Access control is handled exclusively by PermissionGuard on child routes.
 * This guard only checks authentication status.
 */
export const AuthGuard = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const store = inject(Store<AppState>);
  const router = inject(Router);

  return store.select(selectIsInitialized).pipe(
    filter((initialized) => initialized),
    take(1),
    switchMap(() => store.select(selectIsAuthenticated)),
    take(1),
    map((isAuthenticated) => {
      if (!isAuthenticated) {
        const requestedUrl = state.url;
        if (requestedUrl !== '/' && !requestedUrl.startsWith('/auth')) {
          sessionStorage.setItem('compass_return_url', requestedUrl);
        }
        router.navigate(['/auth/login']);
        return false;
      }
      return true;
    })
  );
};
